module.exports = __webpack_public_path__ + "img/plataformaInterativa.64625e97.jpg";